import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import * as types from './types';
export default {
  updateCurrentRoute: function updateCurrentRoute(_ref, payload) {
    var commit = _ref.commit;
    commit(types.SET_CURRENT_ROUTE, payload);
  },
  updatePreviousRoute: function updatePreviousRoute(_ref2, payload) {
    var commit = _ref2.commit;
    commit(types.SET_PREVIOUS_ROUTE, payload);
  }
};